// Unpublished Work © 2026 Deere & Company.

export const SupportedLanguages: string[] = [
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'et',
    'fi',
    'fr',
    'hr',
    'hu',
    'is',
    'it',
    'ja',
    'kk',
    'ko',
    'lt',
    'lv',
    'mk',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'th',
    'tr',
    'uk',
    'zh'
];
